const TARGET_TYPE_NAMES = ['EQUIV', 'AFFECTED']

/**
 * Groups the ranges returned by the performance band ranges endpoint by school and target type:
 * { [schoolId]: { EQUIV: [{start, end, color}], AFFECTED: [{start, end, color}] } }
 *
 * The endpoint has already resolved which set applies to each school, so a school's lists hold exactly
 * the ranges to use for it. Each list is ordered highest band first so a rate exactly on the boundary
 * between two bands belongs to the upper one.
 */
export const groupBandRangesBySchool = (ranges) => {
    const bandsBySchool = {}

    ranges.forEach(range => {
        if (!TARGET_TYPE_NAMES.includes(range.attendance_target_type_name)) return

        if (!bandsBySchool[range.school_id]) {
            bandsBySchool[range.school_id] = { EQUIV: [], AFFECTED: [] }
        }
        bandsBySchool[range.school_id][range.attendance_target_type_name].push({
            start: parseFloat(range.start_value),
            end: parseFloat(range.end_value),
            color: range.attendance_target_descriptor_color
        })
    })

    Object.values(bandsBySchool).forEach(bands => {
        bands.EQUIV.sort((a, b) => b.start - a.start)
        bands.AFFECTED.sort((a, b) => b.start - a.start)
    })

    return bandsBySchool
}
